import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/auth.css';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

// Helper to get CSRF token from cookies
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Helper to ensure CSRF cookie is set
async function ensureCSRFToken() {
  // This endpoint reliably sets the CSRF cookie
  await fetch('/api/csrf/', { credentials: 'include' });
}

export default function PasswordResetPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
  });
  const [isJiggling, setIsJiggling] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');  setSuccess(false);
    
    if (!formData.email) {     setIsJiggling(true);
      setTimeout(() => setIsJiggling(false), 600);
      return;
    }

    try {
      await ensureCSRFToken(); // Ensure CSRF cookie is set before POST
      
      const response = await fetch("/accounts/password/reset/", {
        method: "POST",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRFToken': getCookie("csrftoken"),
        },
        body: new URLSearchParams({       email: formData.email,
        }),
        credentials: "include",
      });

      if (response.ok) {
        setSuccess(true);
        setFormData({ email: "" });
      } else {
        const result = await response.json();
        setError(result.Message || "Password reset failed. Please try again.");
        setIsJiggling(true);
        setTimeout(() => setIsJiggling(false), 60);
      }
    } catch (err) { setError("Network error. Please try again.");
      setIsJiggling(true);
      setTimeout(() => setIsJiggling(false), 60);
    }
  };

  const handleBackToLogin = () => {   navigate("/auth?mode=login");
  };

  return (
    <div className="auth-container">
      <Header />
      <div className="auth-main text-white bg-white">
        <div className="auth-form-container">
          <h1 className="auth-title">Reset Password</h1>
          
          {success ? (
            <div className="success-message" style={{ color: '#009932', marginBottom: '1rem', textAlign: 'center' }}>
              <p>We have sent you an e-mail. Please contact us if you do not receive it within a few minutes.</p>
              <button 
                type="button"
                onClick={handleBackToLogin}
                className="auth-link-btn"
                style={{ marginTop: '1rem' }}
              >
                Back to Login
              </button>
            </div>
          ) : (
            <>
              <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '1.5rem' }}>
                Forgotten your password?<br />
                Enter your e-mail address below, and we'll send you an e-mail allowing you to reset it.
              </p>
              
              {error && (
                <div className="error-message" style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>
                  {error}
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">E-mail*</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    placeholder="E-mail address"
                    className="form-input"
                  />
                </div>
                
                <button type="submit" className={`auth-submit-btn ${isJiggling ? 'jiggle' : ''}`}>
                  Reset My Password
                </button>
              </form>
              
              <div className="auth-links">
                <p className="auth-switch">
                  Remember your password? {" "}
                  <button type="button" onClick={handleBackToLogin} className="auth-link-btn">Log In</button>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
} 